export enum ProcessState {
    SendingRequest = "sendingRequest",
    WaitingResponse = "waitingResponse",
    ConnectionEstablished = "connectionEstablished",
    ConnectionFailure = "connectionFailure",
}